import { render, staticRenderFns } from "./PasswordConfirmationModal.vue?vue&type=template&id=03396aea&"
import script from "./PasswordConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./PasswordConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports